import { render, staticRenderFns } from "./PreProject.vue?vue&type=template&id=5871da45&"
import script from "./PreProject.vue?vue&type=script&lang=js&"
export * from "./PreProject.vue?vue&type=script&lang=js&"
import style0 from "./PreProject.vue?vue&type=style&index=0&id=5871da45&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports